/**
 * @param {string} lastColumnFiltered
 * @param {string} currentColumnFiltered
 * @param {"ASC" | "DESC"} sortDirection
 * @return {function(): "ASC" | "DESC"}
 */

export function defineArrowDirection(lastColumnFiltered, currentColumnFiltered, sortDirection) {
  if (lastColumnFiltered === currentColumnFiltered && sortDirection === 'ASC') {
    return 'DESC'
  }
  if (lastColumnFiltered === currentColumnFiltered && sortDirection === 'DESC') {
    return 'ASC'
  }
  return 'ASC'
}
